import Vue from 'vue';
import Router from 'vue-router';
import Sex from './components/steps/Sex'
import Employment from './components/steps/Employment'
import Age from './components/steps/Age'
import Question from './components/steps/Question'
import Why from './components/steps/Why'
import Result from './components/Result'
import Alcohol from './components/steps/Alcohol'
import AlcoholLittle from './components/steps/AlcoholLittle'
import AlcoholOther from './components/steps/AlcoholOther'
import Calendar from './components/steps/Calendar'

Vue.use(Router);
const myRoutes = [
        
  {
      path: '/',
      redirect: '/1',
  },
  {
    name: 'alcohol',
    path: '/1',
    component: Alcohol,
  },
  {
    name: 'alcohol-little',
    path: '/2',
    component: AlcoholLittle,
  },
  {
    name: 'calendar',
    path: '/3',
    component: Calendar,
  },
  {
    name: 'alcohol-other',
    path: '/4',
    component: AlcoholOther,
  },
  {
    name: 'question-1',
    path: '/5',
    component: Question,
  },
  {
    name: 'question-2',
    path: '/6',
    component: Question,
  },
  {
    name: 'question-3',
    path: '/7',
    component: Question,
  },
  {
    name: 'question-4',
    path: '/8',
    component: Question,
  },
  {
    name: 'question-5',
    path: '/9',
    component: Question,
  },
  {
    name: 'question-6',
    path: '/10',
    component: Question,
  },
  {
    name: 'question-7',
    path: '/11',
    component: Question,
  },
  {
    name: 'question-8',
    path: '/12',
    component: Question,
  },
  
  {
    name: 'sex',
    path: '/13',
    component: Sex,
  },
  {
      name: 'age',
      path: '/14',
      component: Age,
  },
  {
    name: 'employment',
    path: '/15',
    component: Employment,
},
{
    name: 'why',
    path: '/16',
    component: Why,
  },
  {
    name: 'result',
    path: '/17',
    component: Result,
  },
];

const router = new Router({
  //mode: 'abstract',
    routes: myRoutes,
});


export default router;